import { useNavigate, Link } from "react-router-dom";

const ButtonsPanel = ({ buttons }) => {
    return (
        <div className="main-content__button-panel">
            <ul>
                {buttons?.map((button) => (
                    <li key={button.link}>
                        <Link
                            to={button.disabled ? "#" : button.link}
                            onClick={(e) => button.disabled && e.preventDefault()}
                            className={button.disabled ? "disabled" : ""}
                        >
                            <i className={`fa-light ${button.icon || ""}`}></i>
                            <span>{button.title}</span>
                        </Link>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default ButtonsPanel;
